/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import MyLists from '../../MyLists/MyLists';
import { ProductShareIcon } from '../../PDP';
import { useImageGalleryAdditionalButtons } from './hooks/useImageGalleryAdditionalButtons';
import { ImageGalleryAdditionalButtonsStyles } from './ImageGalleryAdditionalButtons.style';

const ImageGalleryAdditionalButtons = ({
  appCtx,
  productId,
  variantId,
  offeringId,
  showMyList,
  page,
  isOutOfStock,
}) => {
  const hookData = useImageGalleryAdditionalButtons({
    appCtx,
    productId,
    variantId,
    offeringId,
    showMyList,
    page,
    isOutOfStock,
  });

  const { shouldRender, shouldShowMyLists, shouldShowShareIcon, productData, handleButtonClick, handleButtonKeyDown } =
    hookData;

  if (!shouldRender) {
    return null;
  }

  return (
    <div className="image-gallery-additional-buttons">
      {shouldShowMyLists && (
        <div
          className="button-container mylists-container"
          onKeyDown={handleButtonKeyDown}
          role="button"
          tabIndex={0}
          onClick={handleButtonClick}
        >
          <MyLists appCtx={appCtx} product={productData} isPDPpage />
        </div>
      )}

      {shouldShowShareIcon && (
        <div className="button-container share-container">
          <ProductShareIcon />
        </div>
      )}

      <style jsx>{ImageGalleryAdditionalButtonsStyles}</style>
    </div>
  );
};

ImageGalleryAdditionalButtons.defaultProps = {
  productId: '',
  variantId: '',
  offeringId: '',
  showMyList: true,
  page: 'PDP',
  isOutOfStock: false,
};

ImageGalleryAdditionalButtons.propTypes = {
  appCtx: PropTypes.object.isRequired,
  productId: PropTypes.string,
  variantId: PropTypes.string,
  offeringId: PropTypes.string,
  showMyList: PropTypes.bool,
  page: PropTypes.string,
  isOutOfStock: PropTypes.bool,
};

export default withApplicationContext(ImageGalleryAdditionalButtons);
export { ImageGalleryAdditionalButtons };
